import React from "react";

const AnnouncementModal = () => {
  return null;
};

export default AnnouncementModal;
